import addCalendarEventsAndNotify from '../store/apis/addCalendarEventsAndNotify';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import createCalendarEventService from '../services/createCalendarEventService';
import expandCalendarEventService from '../services/expandCalendarEventService';
import getDateRange from '../store/apis/getDateRange';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import { CalendarEvent } from 'mini-calendar-event-types';
import { calendarEvent } from 'mini-calendar-event-converter';
import { convertDateRangeToDisplayDateRange } from '../utils/epochTimeToDisplayDate';

/**
 * Creates the calendar event in the server and in the events cache
 * @param item Calendar event to be created
 * @returns Returns the status of create operation, a true is success, false for failure.
 */
export default async function createCalendarEvent(
    event: CalendarEvent
): Promise<ItemInfoResponseMessage> {
    // First make the service call
    const response = await createCalendarEventService(event);

    // Time to check if service was a success
    if (response && response.ResponseClass === 'Success') {
        // Now extract the Calendar Item from service response
        const item = response.Items[0] as CalendarItem;
        item.ParentFolderId = item.ParentFolderId || event.ParentFolderId;
        const calendarEventFromItem = calendarEvent(item);

        // Check if recurrence was created
        if (calendarEventFromItem.isSeriesMaster()) {
            // When recurrence event was created, cache need to be populated by the expanded events retrieved from the server

            // So first get the expanded events
            const cacheRange = getDateRange();
            const transformedCacheRange = convertDateRangeToDisplayDateRange(cacheRange);

            const expandedCalendarEventResponse = await expandCalendarEventService(
                calendarEventFromItem.ItemId,
                transformedCacheRange
            );
            if (expandedCalendarEventResponse) {
                let expandedEvents: CalendarEvent[] = expandedCalendarEventResponse.Occurrences.map(
                    // tslint:disable-next-line:no-unnecessary-callback-wrapper
                    item => calendarEvent(item)
                );

                if (expandedEvents.length > 0) {
                    expandedEvents = expandedEvents.filter(
                        (e: CalendarEvent) => e.ResponseType !== 'Decline'
                    );
                }

                // Add the events in server
                addCalendarEventsAndNotify(expandedEvents);
            }
        } else {
            // Just add the event which was created now
            addCalendarEventsAndNotify([calendarEvent(item)]);
        }
    }
    return Promise.resolve(response);
}
